<!--
 * @Author: xiaokun
 * @Date: 2020-03-02 15:55:03
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-22 17:06:31
 * @Description:  新建/编辑企业活码-第二步
 -->
<template>
  <div class="code-step-two">
    <div class="code-step-two-left">
      <mk-form
        ref="formDataTwo"
        :model="formDataTwo"
        :rules="rules"
        label-width="180px"
        class="form-data-one"
        label-position="right"
      >
        <!-- 中间页标题 -->
        <mk-form-item
          label="中间页标题："
          prop="middlePageTitle"
        >
          <mk-input
            v-model="formDataTwo.middlePageTitle"
            placeholder="默认活码标题"
            maxlength="15"
            show-word-limit
            @blur="updataIframe"
          ></mk-input>
        </mk-form-item>
        <!-- 二维码下方引导文字： -->
        <mk-form-item
          prop="guideText"
        >
          <span slot="label">
            <mk-popover
              placement="bottom-start"
              trigger="hover"
              content="可添加公司简介或者其他描述增加客户信任度，引导客户扫码。"
            >
              <mk-iconfont
                slot="reference"
                icon-class="jingshi"
                class="step-two-tips-icon"
              />
            </mk-popover>二维码下方引导文字：
          </span>
          <mk-input
            v-model="formDataTwo.guideText"
            type="textarea"
            placeholder="长按咨询客服"
            height="80"
            resize="none"
            maxlength="50"
            show-word-limit
            @blur="updataIframe"
          >
          </mk-input>
        </mk-form-item>
        <!-- 图片 -->
        <mk-form-item
          prop="bannerimg"
        >
          <span slot="label">
            图片：
          </span>
          <div class="upload-box">
            <mk-upload-oss-biz
              :bucket="this.$env.VUE_APP_ALI_OSS_BUCKET"
              :limit-size="2"
              accept=".jpg,.png"
              @on-upload="onImageUpload"
            >
              <div
                v-loading="imagesLoading"
                class="upload-cover"
              >
                <div
                  v-if="formDataTwo.image"
                  class="cover-div"
                >
                  <mk-image
                    :src="formDataTwo.image"
                    fit="cover"
                    class="cover-img"
                    alt="cover"
                  />
                  <mk-iconfont
                    icon-class="guanbihuojingshihuocuowu"
                    class="icon"
                    @click.native.stop="clearBannerImg"
                  />
                </div>
                <mk-iconfont
                  v-else
                  icon-class="xinzeng"
                  class="plus-icon"
                />
              </div>
              <mk-button
                type="text"
              >
                点击替换
              </mk-button>
            </mk-upload-oss-biz>
            <div class="upload-tips">
              用于底部banner展示，建议尺寸375*100
            </div>
          </div>
        </mk-form-item>
      </mk-form>
    </div>
    <!-- 右侧同步预览 -->
    <div
      v-if="activeIndex=== 1"
      class="code-step-two-right"
    >
      <code-preview
        :iframe-src="iframeSrc"
        @iframe-loaded="iframeLoaded"
      ></code-preview>
    </div>
  </div>
</template>
<script>
import codePreview from './code-preview'
export default {
  name: 'CodeStepTwo',
  components: { codePreview },
  props: {
    // 是否是编辑 true:是 fasle:否
    isEdit: {
      type: Boolean,
      default: false
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      // 文章封面图片加载
      imagesLoading: false,
      // 表单数据
      formDataTwo: {
        middlePageTitle: '',
        guideText: '',
        image: ''
      },
      // 表单校验
      rules: {
        middlePageTitle: [
          { required: true, message: '请输入中间页标题', trigger: 'blur' },
          { min: 1, max: 15, message: '长度在 1 到 15 个字符', trigger: 'blur' }
        ]
      },
      iframeSrc: ''
    }
  },
  watch: {},
  created () {
    this.createIframeSrc()
  },
  mounted () {},
  methods: {
    // 编辑时 父级数据回显
    setData (data) {
      this.formDataTwo = data
    },
    // 父级调用，获取组件内的数据
    getData () {
      return this.formDataTwo
    },
    // 校验表单方法
    submitForm () {
      let result = ''
      this.$refs.formDataTwo.validate((valid) => {
        result = valid
      })
      return result
    },
    // 底部图片上传
    onImageUpload (res) {
      if (res.type === 'success') {
        this.imagesLoading = false
        this.uploadSuccess(res)
      } else if (res.type === 'fail') {
        this.imagesLoading = false
      } else if (['before', 'progress'].includes(res.type)) {
        this.imagesLoading = true
      }
    },
    // 成功上传
    uploadSuccess (res) {
      this.formDataTwo.image = res.result.url
      this.updataIframe()
    },
    // 删除选中
    clearBannerImg () {
      this.formDataTwo.image = ''
      this.updataIframe()
    },
    // 生成iframe的src
    async createIframeSrc () {
      let { linkUrl } = await this.util.createH5Url({}, 'qrcode', this.$projectScene)
      linkUrl += '&iframeData=yes'
      this.iframeSrc = linkUrl
    },
    // 更新Iframe的值
    updataIframe () {
      this.iframePostDataMessage()
    },
    // iframe加载完毕后的处理
    iframeLoaded (previewIframeDom) {
      this.previewIframeDom = previewIframeDom
      this.iframePostDataMessage()
    },
    // 通过iframe进行【值】传值
    iframePostDataMessage () {
      this.previewIframeDom.contentWindow.postMessage({
        postType: 'data',
        postData: this.formDataTwo
      }, this.iframeSrc)
    }
  }
}
</script>
<style scoped lang="scss">
.code-step-two {
  display: flex;
  align-items: flex-start;
  max-width: 750px;

  .code-step-two-left {
    width: 460px;
    margin-right: 60px;

    .step-two-tips-icon {
      color: #1890ff;
      font-size: 13px;
      margin-right: 6px;
    }
    // 图片上传
    .upload-box {
      text-align: left;

      /deep/ .mk-button {
        padding: 8px 12px 3px 0;
      }

      .cover-img {
        width: 60px;
        height: 60px;
      }

      .upload-tips {
        line-height: 17px;
        color: #bfbfbf;
        font-size: 12px;
      }
    }

    /deep/ .mk-upload-oss {
      .upload-cover {
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        box-sizing: border-box;
        background-color: #fafafa;
        border-radius: 4px;
        border: 1px dashed #d4d4d4;

        .cover-div {
          position: relative;
          width: 60px;
          height: 60px;

          .cover-img {
            width: 100%;
            height: 100%;
          }

          .icon {
            display: none;
            position: absolute;
            top: 0;
            right: 0;
            color: #f5222d;
          }

          &:hover {
            .icon {
              display: block;
            }
          }
        }

        .plus-icon {
          font-size: 27px;
        }
      }

      .el-button--text {
        font-size: 12px;
      }
    }
  }

  .code-step-two-right {
    display: inline-block;
  }
}
// .el-popover--plain
</style>
